import type { PropsWithChildren } from "react";

const WorkspaceFooter = ({ children }: PropsWithChildren) => {
  return <>{children}</>;
};

WorkspaceFooter.displayName = "WorkspaceFooter";

export default WorkspaceFooter;
